var map = {
	"./award.svg": 26704,
	"./building.svg": 64298,
	"./career-01.svg": 96721,
	"./career-02.svg": 39618,
	"./career-03.svg": 43347,
	"./career-04.svg": 20780,
	"./check-round-1.svg": 5014,
	"./check-round-2.svg": 76885,
	"./check-round-3.svg": 4276,
	"./check-round.svg": 58008,
	"./course-01.svg": 44698,
	"./course-02.svg": 59785,
	"./course-03.svg": 24920,
	"./course-04.svg": 44727,
	"./ellipse-1.svg": 36391,
	"./ellipse-2.svg": 64884,
	"./ellipse-3.svg": 90517,
	"./email.svg": 22931,
	"./search-icon.svg": 4533,
	"./student-icon.svg": 42656,
	"./student.svg": 9398,
	"./time.svg": 19214,
	"./winning.svg": 90563
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41349;